/* eslint-disable no-param-reassign */
import produce from 'immer';

import { SET_ALERT } from 'src/actions/alertAction';
import getProductType from 'src/components/ProductType';
const initialState = {
  alertMessage: null,
  variant: 'success',
  redirect: null,
  asOk: false,
  asConfirm: false,
  yesAction: null,
  linkAction: null,
  okAction: false,
  messageAfter: null,
  linkMessage: null
};

const alertReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALERT: {
      const alertMessage = action.payload;
      return produce(state, draft => {
        draft.alertMessage = alertMessage;
        draft.variant = action.payload1;
        draft.redirect = action.redirect
          ? action.redirect.replace('precisa', getProductType().toLowerCase())
          : action.redirect;
        draft.asOk = action.asOk;
        draft.asConfirm = action.asConfirm;
        draft.yesAction = action.yesAction;
        draft.linkAction = action.linkAction;
        draft.okAction = action.okAction;
        draft.linkMessage = action.linkMessage;
        draft.messageAfter = action.messageAfter;
      });
    }
    default: {
      return state;
    }
  }
};

export default alertReducer;
